/**
 * Stockage du token d'accès — **en mémoire uniquement**.
 *
 * Choix de sécurité délibéré : ni `localStorage` ni `sessionStorage`. Un token
 * placé dans le stockage du navigateur est lisible par tout script injecté
 * (XSS, dépendance compromise) et exfiltrable. En mémoire, il disparaît au
 * rechargement de l'onglet.
 *
 * La session survit au rechargement grâce au refresh token, qui vit dans un
 * cookie `httpOnly` inaccessible au JavaScript : au démarrage, l'application
 * rejoue un appel de rafraîchissement pour récupérer un nouveau token d'accès.
 */

let accessToken: string | null = null;

/** Abonnés notifiés à chaque changement (déconnexion d'un autre onglet, expiration). */
const listeners = new Set<(token: string | null) => void>();

export const authToken = {
  get: (): string | null => accessToken,

  set(token: string | null): void {
    accessToken = token;
    listeners.forEach((listener) => {
      listener(token);
    });
  },

  clear(): void {
    this.set(null);
  },

  /** Retourne la fonction de désabonnement. */
  subscribe(listener: (token: string | null) => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
